module.exports = __webpack_public_path__ + "static/media/pega.bb3a8128.svg";